import React from "react";
import { Link } from "react-router-dom";
import { fmtDayLong, fmtTimeRange, kindLabel } from "../lib/dates";
import { fileUrl } from "../api";

/** Seat availability, in the organisation's voice rather than in numbers. */
export function Seats({ g, testid }) {
  // No limit set? Then say nothing: silence reads as "just come".
  if (g.capacity === null || g.capacity === undefined || g.capacity === 0) {
    return null;
  }
  const left = g.seats_left;
  if (left === 0) {
    return (
      <p className="seats seats--full" data-testid={testid}>
        Full <span className="after">&mdash; waitlist only</span>
      </p>
    );
  }
  if (left <= 2) {
    return (
      <p className="seats" data-testid={testid}>
        <b>{left}</b> {left === 1 ? "seat" : "seats"} left
      </p>
    );
  }
  return (
    <p className="seats" data-testid={testid}>
      {left} of {g.capacity} seats
    </p>
  );
}

/** Where it is, honouring "address sent when you write". */
export function Where({ g }) {
  if (g.is_tbc) {
    return (
      <p className="where">
        <span className="tbc">To be confirmed</span>
      </p>
    );
  }
  const bits = [];
  if (g.venue) bits.push(g.venue);
  if (g.address) bits.push(g.address);
  if (!bits.length) return <p className="where">Calgary</p>;
  return (
    <p className="where">
      {bits.join(", ")}
      {g.address_hidden && !g.address ? ", address sent when you write" : ""}
    </p>
  );
}

/**
 * When it is. If the date isn't settled, the organisation's own words stand in
 * for it ("Mid November") rather than a date nobody has agreed to yet.
 */
export function When({ g, testid }) {
  if (g.when_text) {
    return (
      <div className="when when--soft" data-testid={testid}>
        {g.when_text}
        <span className="time">date to be confirmed</span>
      </div>
    );
  }
  return (
    <div className="when" data-testid={testid}>
      {fmtDayLong(g.starts_at)}
      <span className="time">{fmtTimeRange(g.starts_at, g.ends_at)}</span>
    </div>
  );
}

/** One row in the gatherings list. */
export default function GatheringRow({ g, past = false }) {
  return (
    <article
      className={`event${past ? " is-past" : ""}`}
      data-testid={`gathering-row-${g.id}`}
    >
      <When g={g} testid={`gathering-when-${g.id}`} />
      <div>
        <div className="event-top">
          <h3>
            <Link
              to={`/gatherings/${g.id}`}
              style={{ textDecoration: "none" }}
              data-testid={`gathering-title-link-${g.id}`}
            >
              {g.title}
            </Link>
          </h3>
          <span className="kind" data-testid={`gathering-kind-${g.id}`}>
            {kindLabel(g.kind)}
          </span>
        </div>
        <Where g={g} />
        {g.blurb ? <p>{g.blurb}</p> : null}
        {!past ? <Seats g={g} testid={`gathering-seats-${g.id}`} /> : null}
        <div className="actions">
          {!past && g.rsvp_open ? (
            <Link
              to={`/gatherings/${g.id}`}
              className="act"
              data-testid={`gathering-rsvp-link-${g.id}`}
            >
              {g.is_full ? "Join the waitlist \u2192" : "Tell us you're coming \u2192"}
            </Link>
          ) : null}
          {!past ? (
            <a
              className="linkish"
              href={fileUrl(`/gatherings/${g.id}/calendar.ics`)}
              data-testid={`gathering-add-to-calendar-link-${g.id}`}
            >
              Add to calendar (.ics)
            </a>
          ) : null}
        </div>
      </div>
    </article>
  );
}
